import { userIsPublic } from "~/domains/user/utils/roles";
import { getRedirectToRegisterPage } from "~/utils/url/urlUtils";
import { WISHLIST_PAGE } from "~/utils/url/staticUrls";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { useDispatch } from "react-redux";
import { useOnMount } from "~/common/hooks/useOnMount";

import { fetchWishlistNames } from "~/features/wishlist/redux/wishlistSlice";

export const getWishlistNavigationEntryUrl = () => {
  return userIsPublic() ? getRedirectToRegisterPage({ targetPage: WISHLIST_PAGE, openLogin: true }) : WISHLIST_PAGE;
};

export const useLoadWishlistsOnMount = () => {
  const dispatch = useDispatch();
  useOnMount(() => {
    if (userHasPermission(Permission.ADD_TO_WISHLIST)) {
      dispatch(fetchWishlistNames());
    }
  });
};
